import React from 'react';


const categorie = (props) => { 
        return(
            <div>
                <ul className="textAlign">
                    <li onClick={props.selected}>{props.label}</li>
                </ul>
            </div>
        )
}



export default categorie;